/*
 * Keeps the sticky add-to-basket bar's price in step with the Seal Subscriptions
 * option the shopper has chosen (one-time or Subscribe & Save). Display only:
 * the sticky button still submits the main product form, which carries
 * Seal's selling_plan input.
 */
(() => {
  let queued = false;

  const sync = () => {
    queued = false;
    const stickyPrice = document.querySelector('.sticky-add-to-cart__price');
    const activePrice = document.querySelector(
      '.product-details .sealsubs-container .sls-option-container.sls-active .sls-price .money'
    );
    if (!stickyPrice || !activePrice) return;

    const text = activePrice.textContent.trim();
    if (!text || stickyPrice.textContent.trim() === text) return;

    const span = document.createElement('span');
    span.className = 'price';
    span.textContent = text;
    stickyPrice.replaceChildren(span);
  };

  const queue = () => {
    if (queued) return;
    queued = true;
    setTimeout(sync, 120);
  };

  const start = () => {
    const details = document.querySelector('.product-details');
    const sticky = document.querySelector('sticky-add-to-cart');
    if (!details || !sticky) return;

    const options = { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] };
    new MutationObserver(queue).observe(details, options);
    new MutationObserver(queue).observe(sticky, { childList: true, subtree: true, characterData: true });
    queue();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
